module.exports = __webpack_public_path__ + "img/informasi-rekening-active.45325b7d.svg";